import { FC } from 'react';
import { useMerchants } from '../../store/merchnts/merchants-context';
import { NotificationComponent } from './NotificationComponent';
import { NewApplication } from './NewApplication';
import { STATUSES } from '../../views/login/Login';

export const ApplicationDetailsApplicationForm: FC = () => {
  const { merchantState: { applicationData }} = useMerchants();
  return (
    <>
      {
        applicationData?.statusName === STATUSES.SUBMITTED && (
          <NotificationComponent
            title="Submitted application"
            text="Since the application has already been submitted, these values are locked and cannot be changed."
            containerAdditionalClass="mb-5"
          />
        )
      }

      <NewApplication />
    </>
  );
};